import { all } from 'redux-saga/effects';
// import authSagas from './auth/saga';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function* rootSaga(getState) {
  yield all([
    // authSagas(),
  ]);
}
